import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["checked"]
const _hoisted_2 = { class: "message-content__data py-4 px-8 text-2xl text-left text-overflow !max-w-[25vw]" }
const _hoisted_3 = { class: "message-content__data font-bold py-4 px-8 text-2xl text-lef hover:text-gray-400" }
const _hoisted_4 = { class: "message-content__data font-bold py-4 px-8 text-2xl text-left hover:text-gray-400" }
const _hoisted_5 = { class: "message-content__data py-4 px-8 text-2xl text-left hover:text-gray-400" }
const _hoisted_6 = { class: "status-change-container" }
const _hoisted_7 = { class: "tag-area-container" }
const _hoisted_8 = {
  key: 0,
  class: "existing-tags-displayer flex gap-2"
}
const _hoisted_9 = {
  key: 1,
  class: "no-tags text-2xl italic text-gray-400"
}
const _hoisted_10 = { class: "message-content__data py-4 px-8 text-left text-2xl text-overflow !max-w-[25vw]" }
const _hoisted_11 = ["href"]
const _hoisted_12 = { class: "message-content__data py-4 px-8 text-2xl text-left hover:text-gray-400" }

import { ref } from "vue"
    import { useMultiSelectEMails } from "@/composables/crmBasedFunctions";
    import { EMailTag } from "@/types";

    import textToggler from "../reusable/textToggler.vue";
    import statusChanger from "../reusable/statusChanger.vue";
    import tagViewer from "../reusable/tagViewer.vue";

    
export default /*#__PURE__*/_defineComponent({
  __name: 'EMailRow',
  props: ['email', 'currentTagToggledEmail', 'tagList'],
  emits: ['tag-added', 'tag-deleted', "edit", "single-field-update"],
  setup(__props, { emit: __emit }) {

    const props = __props
    const emits = __emit

    const { selectedEMails } = useMultiSelectEMails()

    const handleSelection = (id: string) => {
        if(!selectedEMails.value.includes(id)){
            selectedEMails.value.push(id)
        }
        else{
            selectedEMails.value.splice(selectedEMails.value.indexOf(id), 1)
        }
    }

    const isAddingTag = ref(false)

    const emitTagAdded = (tag: EMailTag) => {
        emits('tag-added', tag)
        isAddingTag.value = false
    }

    const emitTagDeleted = (tag: EMailTag) => {
        emits('tag-deleted', tag)
    }

    const emitEdit = () => {
        emits('edit', props.email)
    }

    // Reverse the tags, so that the last added tag appears first.

    const getReversedTags = (tags: EMailTag[]) => {
        return [...tags].reverse();
    }

    const emitSingleFieldUpdate = (field: string, value: string) => {
        emits('single-field-update', { field, value })
    }



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("tr", null, [
    _createElementVNode("td", {
      onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
    }, [
      _createElementVNode("input", {
        checked: _unref(selectedEMails).includes(__props.email.id),
        onChange: _cache[0] || (_cache[0] = ($event: any) => (handleSelection(__props.email.id))),
        type: "checkbox",
        class: "table-checkbox !w-4"
      }, null, 40, _hoisted_1)
    ]),
    _createElementVNode("td", _hoisted_2, _toDisplayString(__props.email.email), 1),
    _createElementVNode("td", _hoisted_3, [
      _createVNode(textToggler, {
        class: "text-black",
        "edited-field": "firstName",
        text: __props.email.firstName,
        onCompleteEdit: _cache[2] || (_cache[2] = ($event: any) => (emitSingleFieldUpdate('firstName', $event)))
      }, null, 8, ["text"])
    ]),
    _createElementVNode("td", _hoisted_4, [
      _createVNode(textToggler, {
        class: "text-black",
        "edited-field": "lastName",
        text: __props.email.lastName,
        onCompleteEdit: _cache[3] || (_cache[3] = ($event: any) => (emitSingleFieldUpdate('lastName', $event)))
      }, null, 8, ["text"])
    ]),
    _createElementVNode("td", _hoisted_5, [
      _createVNode(textToggler, {
        class: "text-black",
        "edited-field": "industry",
        text: __props.email.industry,
        onCompleteEdit: _cache[4] || (_cache[4] = ($event: any) => (emitSingleFieldUpdate('industry', $event)))
      }, null, 8, ["text"])
    ]),
    _createElementVNode("td", {
      onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (isAddingTag.value = true), ["exact"])),
      class: "scrolling-table-field hover:bg-gray-200 cursor-pointer relative"
    }, [
      _createElementVNode("div", _hoisted_6, [
        (isAddingTag.value)
          ? (_openBlock(), _createBlock(statusChanger, {
              key: 0,
              "existing-statuses": __props.email.tags,
              "status-list": __props.tagList,
              "displays-triangle": true,
              onUpdated: _cache[5] || (_cache[5] = ($event: any) => (emitTagAdded($event))),
              onCancelled: _cache[6] || (_cache[6] = ($event: any) => (isAddingTag.value = false)),
              title: "Etiket Ekle",
              class: "status-changer absolute !w-[20vw] top-[70%] left-[-25%] !z-50"
            }, null, 8, ["existing-statuses", "status-list"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_7, [
        (__props.email.tags?.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getReversedTags(__props.email.tags), (tag) => {
                return (_openBlock(), _createBlock(tagViewer, {
                  onDeleteTag: _cache[7] || (_cache[7] = ($event: any) => (emitTagDeleted($event))),
                  removable: true,
                  key: tag.id,
                  tag: tag
                }, null, 8, ["tag"]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_9, " Etiket yok. "))
      ])
    ]),
    _createElementVNode("td", _hoisted_10, [
      (__props.email.companyUrl)
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            target: "_blank",
            href: __props.email.companyUrl,
            class: "text-blue-500"
          }, _toDisplayString(__props.email.company), 9, _hoisted_11))
        : (_openBlock(), _createBlock(textToggler, {
            key: 1,
            class: "!overflow-x-scroll no-scrollbars",
            "edited-field": "company",
            text: __props.email.company,
            onCompleteEdit: _cache[9] || (_cache[9] = ($event: any) => (emitSingleFieldUpdate('company',$event)))
          }, null, 8, ["text"]))
    ]),
    _createElementVNode("td", _hoisted_12, [
      _createVNode(textToggler, {
        class: "text-black",
        "edited-field": "phone",
        text: __props.email.phone,
        onCompleteEdit: _cache[10] || (_cache[10] = ($event: any) => (emitSingleFieldUpdate('phone', $event)))
      }, null, 8, ["text"])
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("button", {
        onClick: emitEdit,
        class: "table-button"
      }, "Düzenle")
    ])
  ]))
}
}

})